import { css } from "@emotion/react";
import { forwardRef } from "react";
import { useTheme } from "../theme";

export interface SwitchProps extends Omit<
  React.ComponentPropsWithoutRef<"input">,
  "size"
> {
  checked?: boolean;
  defaultChecked?: boolean;
  name?: string;
  value?: string;
  /**
   * 大きさを指定します。
   *
   * @default medium
   */
  size?: "small" | "medium" | "large";
}

const switchTrackWidths = {
  small: 22,
  medium: 32,
  large: 46,
};
const switchTrackHeights = {
  small: 12,
  medium: 16,
  large: 24,
};

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ size = "medium", className, style, ...props }, ref) => {
    const theme = useTheme();
    return (
      <span
        className={className}
        style={style}
        css={css`
          --switch-thumb-x: calc(
            var(--switch-track-width) - var(--switch-track-height)
          );
          --switch-track-width: ${switchTrackWidths[size]}px;
          --switch-track-height: ${switchTrackHeights[size]}px;
          position: relative;
          display: inline-flex;
          align-items: center;
          vertical-align: middle;
          cursor: pointer;
        `}
      >
        <input
          ref={ref}
          css={css`
            position: absolute;
            top: 0px;
            left: -20%;
            z-index: 1;
            width: 140%;
            height: 100%;
            padding: 0px;
            margin: 0px;
            cursor: inherit;
            opacity: 0;
          `}
          type="checkbox"
          {...props}
        />
        <span
          css={css`
            box-sizing: content-box;
            display: inline-flex;
            flex-shrink: 0;
            justify-content: flex-start;
            width: var(--switch-track-width);
            height: var(--switch-track-height);
            padding: 2px;
            cursor: pointer;
            background: rgb(203, 213, 224);
            border-radius: 9999px;
            transition-duration: 150ms;
            transition-property:
              background-color, border-color, color, fill, stroke, opacity,
              box-shadow, transform;
            -webkit-box-pack: start;
            input:checked + & {
              background-color: ${theme.palette.intentions.primary.main};
            }
            input:disabled + & {
              cursor: not-allowed;
              opacity: 0.4;
            }
          `}
        >
          <span
            css={css`
              width: var(--switch-track-height);
              height: var(--switch-track-height);
              background: #ffffff;
              border-radius: inherit;
              transition-duration: 200ms;
              transition-property: transform;
              input:checked + * > & {
                transform: translateX(var(--switch-thumb-x));
              }
            `}
          />
        </span>
      </span>
    );
  },
);
